export const REGION_LABELS = {
  us: 'United States',
  europe: 'Europe',
  india: 'India',
  middle_east: 'Middle East',
  east_asia: 'East Asia',
  global: 'Wire Services'
};

export const REGION_ORDER = ['us', 'europe', 'india', 'middle_east', 'east_asia'];
